enum SteeredCaseType {
  EXISTING_CUSTOMER = 'existingCustomer',
  GENUINELY_STEERED = 'genuinelySteered'
}

export default SteeredCaseType;
